import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../../app.service';
import { ProjectPartsLitsVM } from '../add-fecr-recommendation/add-fecr-recommendation';
import { FrontEndComponetService } from '../front-end-componet.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fecr-parts-list',
  templateUrl: './fecr-parts-list.component.html',
  styleUrls: ['./fecr-parts-list.component.scss']
})
export class FecrPartsListComponent implements OnInit {
  ImplementId:number;
  ImplementName:string;
  loading:boolean=false;
  ProjectPartsList:ProjectPartsLitsVM[]=[];
  constructor(
    private _fecrService: FrontEndComponetService,
    private _appService: AppService, public dialogRef: MatDialogRef<FecrPartsListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _sanitizer: DomSanitizer,
    public addRepairerWorkshopModal: MatDialog,
    public toastr: NotificationsService, vcr: ViewContainerRef) {
    
  }

  ngOnInit() {
    this.ImplementId = this.data.implementId;
    this.ImplementName = this.data.implementName;
    this.loadProjectPartsList();
    //this.LoadProjectContacts();

  }

  loadProjectPartsList(){
    this.loading=true;
    this._fecrService.GETProjectPartsList(this.ImplementId).subscribe(res=>{
      this.ProjectPartsList = res;
      this.loading=false;
    })
  }
  ExportToExcel() {
    this.downloadFile(this.ProjectPartsList)
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }
    //download csv file
    downloadFile(data: any) {

      console.log("data", data)
  
     
  
      let _data = []
  
      data.map(p => {
        let _o = {}
        for (var key in p) {
          if (p.hasOwnProperty(key)) {
  
            if(key == "ObsPointName"){
              _o["Observation Point"] = p[key]
            }else if(key == "PartsList"){
              _o["Parts List"] = p[key]
            }
          }
      }
  
      _data.push(_o)
      })
  
      const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
      const header = Object.keys(_data[0]);
      let csv = _data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
      csv.unshift(header.join(','));
      let csvArray = csv.join('\r\n');
      var a = document.createElement('a');
      var blob = new Blob([csvArray], { type: 'text/csv' }),
        url = window.URL.createObjectURL(blob);
  
      a.href = url;
      a.download = `Project_Parts_List ${this.ImplementName}.csv`;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    }
  

}
